import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "../AdmForms/AdmForm.css";
import axios from "../../utils/axiosConfig";
import { useRef } from "react";

const AdmForm = () => {

  const [captcha, setCaptcha] = useState(null);
  const formRef = useRef();
  const [photo, setPhoto] = useState(null);
  const [studentName, setStudentName] = useState("");
  const [dob, setDob] = useState("");
  const [age, setAge] = useState({ years: "", months: "", days: "" });
  const [dobWords, setDobWords] = useState("");
  const [admissionYear, setAdmissionYear] = useState("");

  const [errors, setErrors] = useState({});

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (!name) return;
    setErrors((prev) => ({
      ...prev,
      [name]: value.trim() === ""
    }));
  };


  const handlePhotoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    // ❗ Resize + compress image
    const compressImage = (file) => {
      return new Promise((resolve) => {
        const img = new Image();
        const reader = new FileReader();
  
        reader.onload = (e) => {
          img.src = e.target.result;
        };
  
        img.onload = () => {
          const canvas = document.createElement("canvas");
  
          // 🔥 Resize (VERY IMPORTANT)
          const MAX_WIDTH = 300;
          const scale = MAX_WIDTH / img.width;
  
          canvas.width = MAX_WIDTH;
          canvas.height = img.height * scale;
  
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  
          // 🔥 Reduce quality
          const compressedBase64 = canvas.toDataURL("image/jpeg", 0.6);
          resolve(compressedBase64);
        };
  
        reader.readAsDataURL(file);
      });
    };
  
    const base64 = await compressImage(file);
  
    setPhoto(base64);
  };

  // 🔢 NUMBER → WORDS
  const numberToWords = (num) => {
    const a = ["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten",
    "Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
    const b = ["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
  
    if (num < 20) return a[num];
    if (num < 100) return b[Math.floor(num / 10)] + " " + a[num % 10];
    return num;
  };

  const formatDateWords = (date) => {
    if (!date) return "";
    const d = new Date(date);

    const day = numberToWords(d.getDate());
    const month = d.toLocaleString("default", { month: "long" });
    const year = d.getFullYear();

    return `${day} ${month} ${year}`;
  };

  // 📅 AGE CALCULATION
  const calculateAge = (dob, year) => {
    if (!dob || !year) return { years: "", months: "", days: "" };
  
    const birthDate = new Date(dob);
  
    // ✅ USER ENTERED YEAR
    const refDate = new Date(`${year}-04-01`);
  
    let years = refDate.getFullYear() - birthDate.getFullYear();
    let months = refDate.getMonth() - birthDate.getMonth();
    let days = refDate.getDate() - birthDate.getDate();
  
    if (days < 0) {
      months--;
      const prevMonth = new Date(refDate.getFullYear(), refDate.getMonth(), 0);
      days += prevMonth.getDate();
    }
  
    if (months < 0) {
      years--;
      months += 12;
    }
  
    return { years, months, days };
  };

  const formatDateIST = (date) => {
    if (!date) return "";
  
    const d = new Date(date);
  
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
  
    return `${day}-${month}-${year}`;
  };

   // ✅ SUBMIT VALIDATION
  const handleSubmit = async () => {

    if (!captcha) {
      alert("Please verify captcha");
      return;
    }
    const inputs = document.querySelectorAll(".line, textarea");
  
    let valid = true;
  
    inputs.forEach((input) => {
      if (input.disabled) return;
      if (!input.dataset.required) return;
  
      if (!input.value.trim()) {
        input.classList.add("error");
        valid = false;
      } else {
        input.classList.remove("error");
      }
    });
  
    if (!photo) {
      alert("Photo is required");
      return;
    }
  
    if (!valid) {
      alert("Please fill required fields");
      return;
    }
      try {
        const formData = {
          student_name: studentName,
          photo: photo,
          session: (document.querySelector('[name="session"]') || {}).value,
          class: (document.querySelector('[name="class"]') || {}).value,
          classsought: (document.querySelector('[name="classsought"]') || {}).value,
          sex: (document.querySelector('[name="sex"]') || {}).value,
          
          dateofbirth: formatDateIST(dob),
          currdate: formatDateIST((document.querySelector('[name="currdate"]') || {}).value),

          inwords: dobWords,
          ageapril: admissionYear,
          years: age.years,
          months: age.months,
          days: age.days,
          placeofbirth: (document.querySelector('[name="placeofbirth"]') || {}).value,
          district: (document.querySelector('[name="district"]') || {}).value,
          state: (document.querySelector('[name="state"]') || {}).value,
        
          nationality: (document.querySelector('[name="nationality"]') || {}).value,
          whether: (document.querySelector('[name="whether"]') || {}).value,
        
          fathername: (document.querySelector('[name="fathername"]') || {}).value,
          mothername: (document.querySelector('[name="mothername"]') || {}).value,
        
          permanentadd: (document.querySelector('[name="permanentadd"]') || {}).value,
          presentadd: (document.querySelector('[name="presentadd"]') || {}).value,
        
          contactno: (document.querySelector('[name="contactno"]') || {}).value,
          residence: (document.querySelector('[name="residence"]') || {}).value,
          mobileno: (document.querySelector('[name="mobileno"]') || {}).value,
        
          occupation: (document.querySelector('[name="occupation"]') || {}).value,
        
          // whetherward: (document.querySelector('[name="whetherward"]') || {}).value,
          // tick: (document.querySelector('[name="tick"]') || {}).checked ? "✔" : "",
        
          nriname: (document.querySelector('[name="nriname"]') || {}).value,
          oldnorth: (document.querySelector('[name="oldnorth"]') || {}).value,
        
          schoolstudy: (document.querySelector('[name="schoolstudy"]') || {}).value,
          recognized: (document.querySelector('[name="recognized"]') || {}).value,
          datesfrom: (document.querySelector('[name="datesfrom"]') || {}).value,
          medium: (document.querySelector('[name="medium"]') || {}).value,
          presentclass: (document.querySelector('[name="presentclass"]') || {}).value,
        
          subjectsclass: (document.querySelector('[name="subjectsclass"]') || {}).value,
          hobbies: (document.querySelector('[name="hobbies"]') || {}).value,
          medical: (document.querySelector('[name="medical"]') || {}).value,
          bloodgroup: (document.querySelector('[name="bloodgroup"]') || {}).value,
        
          guardian: (document.querySelector('[name="guardian"]') || {}).value,
          other: (document.querySelector('[name="other"]') || {}).value,
        
          decclass: (document.querySelector('[name="decclass"]') || {}).value,
          currplace: (document.querySelector('[name="currplace"]') || {}).value,
          legalguardian: (document.querySelector('[name="legalguardian"]') || {}).value,

          peradd: (document.querySelector('[name="peradd"]') || {}).value,
          preadd: (document.querySelector('[name="preadd"]') || {}).value,

          subclass1: (document.querySelector('[name="subclass1"]') || {}).value,
          subclass2: (document.querySelector('[name="subclass2"]') || {}).value,
          subclass3: (document.querySelector('[name="subclass3"]') || {}).value,

          hobbies1: (document.querySelector('[name="hobbies1"]') || {}).value,
          medical1: (document.querySelector('[name="medical1"]') || {}).value,
          guardian1: (document.querySelector('[name="guardian1"]') || {}).value,
          other1: (document.querySelector('[name="other1"]') || {}).value,

          captcha: captcha,
        
        };

        const res = await axios.post(
          "/api/forms/generate-pdf",
          formData
        );
        
	if (res.data.success) {
  	   alert("Form Submitted Successfully");
	}    
        
	alert("PDF Generated Successfully");
        resetForm();
        window.scrollTo({ top: 0, behavior: "smooth" });
        
      } catch (err) {
        console.error(err);
        alert("Error saving form");
      }
    };


  const resetForm = () => {
    // Clear all input fields
    const inputs = document.querySelectorAll(".line, textarea, .line-row");
    inputs.forEach((input) => {
      input.value = "";
      input.classList.remove("error");
    });
  
    // Clear textarea
    const textareas = document.querySelectorAll("textarea");
    textareas.forEach((t) => (t.value = ""));
  
    // Reset states
    setPhoto(null);
    setDob("");
    setDobWords("");
    setAge({ years: "", months: "", days: "" });
    setAdmissionYear("");
  
    // Clear file input manually
    const fileInput = document.querySelector(".photo-box input");
    if (fileInput) fileInput.value = "";
  };

  

  // 📞 PHONE VALIDATION
  const handlePhone = (e) => {
    e.target.value = e.target.value
      .replace(/[^0-9]/g, "")
      .slice(0, 10);
  };


  return (
    <div className="a4-page">
      {/* <div className="form"> */}
      <div className="form" ref={formRef}>

        {/* HEADER */}
        <div className="header">
          <h2>NORTH POINT CHILDREN’S ACADEMY</h2>
        </div>

        {/* TOP GRID */}
        <div className="top-grid">

          <div className="top-left">
            <p>50, TAPKESHWAR ROAD, D.DUN CANTT</p>
            <p>Phone: 0135-3598009, 9456311713</p>
            <p className="affiliation">
              Affiliated to the Council for ISCE (10+2), New Delhi
            </p>

            <div className="line-row">
              Admission for Session 
              <input name="session" autoComplete="off" onBlur={handleBlur} className={`line w150 ${errors.session ? "error" : ""}`} data-required="true" style={{ textTransform: "uppercase", fontWeight: "bold"}} />
              For Class 
              <input name="class" autoComplete="off" onBlur={handleBlur} className={`line w120 ${errors.class ? "error" : ""}`} data-required="true" style={{ textTransform: "uppercase", fontWeight: "bold"}}/>
            </div>
          </div>

          {/* ✅ FULL CLICKABLE PHOTO FIX */}
          <div className="photo-box" style={{ fontWeight: "bold"}}>
            {photo ? <img src={photo} alt="" /> : "Click Upload Photo"}
            <input
                type="file"
                accept="image/*"
                onChange={handlePhotoChange}
            />
          </div>
        </div>

        {/* OFFICE BOX */}
        <div className="office-box">
          <b>(To be Filled in by School Office)</b>

          <div className="line-row">
            Joined on <input disabled className="line w110" />
            in Class <input disabled className="line w120" />
            Admission/Reg. No <input disabled className="line w180" />
          </div>

          <div className="line-row">
            L.F No <input disabled className="line w110" />
            Roll No <input disabled className="line w120" />
            Aadhar Card No <input disabled className="line w220" />
          </div>
        </div>

        {/* STUDENT */}
        <div className="line-row">
          Name (In full) of Candidate (In Block Letters)
          {/* <input name="student_name" className="line flex" data-required="true" style={{ textTransform: "uppercase", fontWeight: "bold"}} /> */}
          <input name="student_name" className="line flex" data-required="true" value={studentName} onChange={(e) => setStudentName(e.target.value)} style={{ textTransform: "uppercase", fontWeight: "bold" }} />
          Sex <input name="sex" className="line w80" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>

        <div className="line-row">
          Class for which admission is sought
          <input name="classsought" className="line flex" data-required="true" style={{ textTransform: "uppercase", fontWeight: "bold"}}/>
        </div>

        <div className="line-row">
          Date of Birth <input name="dateofbirth" type="date" className="line w150" style={{ textTransform: "uppercase", fontWeight: "bold"}} value={dob} onChange={(e) => {
          const value = e.target.value;
          setDob(value);

          const result = calculateAge(value);
          setAge(result);

          setDobWords(formatDateWords(value));
        }} 
          data-required="true"
        />
          in Words <input name="inwords" className="line flex" style={{ textTransform: "capitalize", fontWeight: "bold"}} value={dobWords} readOnly />
        </div>
        

        <div className="line-row">
          Place of Birth <input name="placeofbirth" className="line w180" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
          District <input name="district" className="line w160" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
          State <input name="state" className="line w160" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>

        <div className="line-row">
          Age as on 1st April
          {/* ✅ USER ENTER YEAR */}
          <input
            name="ageapril"
            className="line w100"
            style={{ textTransform: "capitalize", fontWeight: "bold"}}
            placeholder="Year"
            value={admissionYear}
            onChange={(e) => {
              const year = e.target.value.replace(/[^0-9]/g, "").slice(0, 4);
              setAdmissionYear(year);

              const result = calculateAge(dob, year);
              setAge(result);
            }}
            data-required="true"
          /> Years

          <input name="years" className="line w105" style={{ textTransform: "capitalize", fontWeight: "bold"}} value={age.years} readOnly /> Months
          <input name="months" className="line w105" style={{ textTransform: "capitalize", fontWeight: "bold"}} value={age.months} readOnly /> Days
          <input name="days" className="line w90" style={{ textTransform: "capitalize", fontWeight: "bold"}} value={age.days} readOnly />
        </div>


        <div className="line-row">
          Nationality <input name="nationality"  className="line w220" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
          Whether  SC/ST/OBC/Gen <input name="whether" className="line w210" data-required="true" style={{ textTransform: "uppercase", fontWeight: "bold"}}/>
        </div>

        {/* PARENTS */}
        <div className="line-row">
          Name of Father (In full)<input name="fathername" className="line flex" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>

        <div className="line-row">
          Name of Mother (In full)<input name="mothername" className="line flex" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>

        <div className="line-row">
          Permanent Address of Parent in Full <input name="permanentadd" className="line flex" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>
        <div className="line-row">
          <input name="peradd" className="line w300" style={{ textTransform: "capitalize", fontWeight: "bold"}} />
        </div>

        <div className="line-row">
          Present Address of Parent in Full <input name="presentadd" className="line flex" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>
        <div className="line-row">
          <input name="preadd" className="line w300" style={{ textTransform: "capitalize", fontWeight: "bold"}} />
        </div>

        <br/>
        
        <div className="line-row">
          Contact Phone Nos. with ISD/STD Codes Office Phone 
          <input name="contactno" className="line w285" style={{ textTransform: "capitalize", fontWeight: "bold"}} onInput={handlePhone} data-required="true" />
        </div>

        <div className="row-tab">
          <div className="line-row">
            Residence. :<input name="residence" className="line w286" style={{ textTransform: "capitalize", fontWeight: "bold"}} onInput={handlePhone} data-required="true" />
          </div>
        </div>

        <div className="row-tab">
          <div className="line-row">
            Mobile No.: 
            <input name="mobileno" className="line w286" style={{ textTransform: "capitalize", fontWeight: "bold"}} onInput={handlePhone} data-required="true" />
          </div>
        </div>

        <div className="line-row">
          Occupation <input name="occupation" className="line flex" style={{ textTransform: "uppercase", fontWeight: "bold"}} data-required="true" />
        </div>

                {/* WHETHER WARD */}
        <div className="line-row">
        Whether Ward of :
        {/* <input name="whetherward" className="line flex" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        (Tick) <input name="tick" type="checkbox" className="tick-box" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        <input className="line w200" style={{ textTransform: "capitalize", fontWeight: "bold"}}/> */}
        </div>

        <div className="line-row">
        (a) NRI's mention name of country settled in :
        <input name="nriname" className="line flex" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>

        <div className="line-row">
        (b) Old Northanians mention Passing out Year :
        <input name="oldnorth" className="line flex" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>

        {/* TABLE */}
        <table className="table" >
          <thead>
            <tr>
              <th style={{ background: "white"}}>Name and Address of School Studying at present</th>
              <th style={{ background: "white"}}>Recognized or Unrecognized</th>
              <th style={{ background: "white"}}>Dates From to</th>
              <th style={{ background: "white"}}>Medium of Instruction</th>
              <th style={{ background: "white"}}>Class in which studying at present</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><textarea name="schoolstudy" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold", textAlign: "justify"}}/></td>
              <td><textarea name="recognized" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold" , textAlign: "center"}}/></td>
              <td><textarea name="datesfrom" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold" , textAlign: "center"}}/></td>
              <td><textarea name="medium" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold" , textAlign: "center"}}/></td>
              <td><textarea name="presentclass" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold" , textAlign: "center"}}/></td>
            </tr>
          </tbody>
        </table>

        <div className="left-side">
          <p >P.T.O</p>
        </div>


{/* SECOND PAGE START FROM HERE */}
        {/* SUBJECTS */}

        <div className="line-row">
        Subjects being opted in the present class <input name="subjectsclass" className="line flex" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>
        
        <div className="line-row">
          <input name="subclass1" className="line w300" style={{ textTransform: "capitalize", fontWeight: "bold"}} />
          <input name="subclass2" className="line w300" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
          <input name="subclass3" className="line w300" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>


        {/* HOBBIES */}
        <div className="line-row">
        Details of Hobbies <input name="hobbies" className="line flex" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>
        
        <div className="line-row">
          <input name="hobbies1" className="line w300" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>


        {/* MEDICAL */}
        <div className="line-row">
        Particulars of any physical or mental ailments, serious illness, 
        infectious disease from which the ward has suffered if any :  <input name="medical" className="line flex" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>
        <div className="line-row">
          <input name="medical1" className="line w300" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>
    

        {/* BLOOD GROUP */}
        <div className="line-row">
        Blood Group <input name="bloodgroup" className="line flex" data-required="true" style={{ textTransform: "uppercase", fontWeight: "bold"}}/>
        </div>


        {/* GUARDIAN */}
        <div className="line-row">
        Name and address of legal guardian (If any, with relationship with the candidate)
        for purpose of admission, withdrawal, payment of fees and other official correspondence <input name="guardian" className="line flex" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>  
        <div className="line-row">
          <input name="guardian1" className="line w300" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>

        {/* OTHER INFO */}
        <div className="line-row">
        Any other information which the school should know <input name="other" className="line flex" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>
        
        <div className="line-row">
          <input name="other1" className="line w300" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
        </div>

        {/* DECLARATION */}
        <div className="declaration">
        <h4 style={{ color: "black"}}>DECLARATION</h4>

        <p className="decl-text">
            I agree to abide by the school rules and regulations and will also accept
            changes which may be made in it from time to time. I hereby declare that
            the above information given by me is true to my knowledge and belief.
            I request that my above-named ward may be registered for admission test
            in your school for Class:
            <input name="decclass" className="line w200" data-required="true" style={{ textTransform: "uppercase", fontWeight: "bold"}}/>
        </p>

        <div className="sign-row">
          <div className="sign-left">
            Place: <input name="currplace" className="line w150" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
          </div>

          <div className="sign-right">
            Signature of Parent/Legal Guardian <br />
          </div>
        </div>

        <div className="sign-row">
          <div className="sign-left">
            Date: <input name="currdate" type="date" className="line w150" data-required="true" style={{ textTransform: "uppercase", fontWeight: "bold"}}/>
          </div>

          <div className="sign-right">
            Name: <input name="legalguardian" className="line w200" data-required="true" style={{ textTransform: "capitalize", fontWeight: "bold"}}/>
          </div>
        </div>

        <div style={{ marginTop: "20px" }}>
          <ReCAPTCHA
            sitekey="6Lf7oNMsAAAAAETiWwBj-narLfqUej71jqWTPnBW"
            onChange={(value) => setCaptcha(value)}
          />
        </div>
        <div className="submit-area">
          <button onClick={handleSubmit}>Submit</button>
        </div>
          

      </div>
      </div>
    </div>
  );
};

export default AdmForm;